import React from 'react';
import { Space, Typography, Image, Tooltip, Card, Divider } from 'antd';
import { LinkOutlined, EditOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text, Title } = Typography;

export default function ProductInfoCard({ scannedItem, onQuickEdit }) {
  const { t } = useTranslation();
  if (!scannedItem) return null;

  const isCreateMode = !scannedItem.id;
  const hasBeenVerified = !!scannedItem.received_at && !isCreateMode;
  const receiptItems = scannedItem.receipt_items || [];
  const totalReceived = receiptItems.reduce((sum, ri) => sum + (ri.quantity || 0), 0);

  return (
    <div style={{ marginBottom: 20 }}>
      <div style={{ display: 'flex', gap: 16, alignItems: 'flex-start' }}>
        {scannedItem.product_image_url && (
          <Image
            src={scannedItem.product_image_url}
            width={80}
            height={80}
            style={{ borderRadius: 8, objectFit: 'contain', border: '1px solid #f0f0f0' }}
            fallback="placeholder.png"
          />
        )}
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
            <Title level={5} style={{ margin: 0 }}>{scannedItem.product_name}</Title>
            {isCreateMode && (
              <span style={{ fontSize: 12, background: '#f50', color: '#fff', padding: '2px 6px', borderRadius: 4 }}>
                Unplanned
              </span>
            )}
          </div>
          <Space size="middle">
            <Text copyable style={{ fontFamily: 'monospace' }}>{scannedItem.product_sku}</Text>
            <Tooltip title={t('common.button.view')}>
              <a href={`/operator/products/${scannedItem.product_id}`} target="_blank" rel="noopener noreferrer">
                <LinkOutlined style={{ color: '#1890ff' }} />
              </a>
            </Tooltip>
            {onQuickEdit && (
              <Tooltip title={t('shared.products.quick_edit.title')}>
                <EditOutlined style={{ color: '#1890ff', cursor: 'pointer' }} onClick={onQuickEdit} />
              </Tooltip>
            )}
          </Space>
          {scannedItem.product_barcode && (
            <div style={{ marginTop: 4 }}>
              <Text type="secondary" style={{ fontSize: 12 }}>
                {t('product.barcode', { defaultValue: '條碼' })}: {scannedItem.product_barcode}
              </Text>
            </div>
          )}
        </div>
      </div>

      <Card size="small" style={{ background: '#f9f9f9', marginTop: 12 }} bordered={false}>
        <Space split={<Divider type="vertical" />} size="large">
          <div>
            <Text type="secondary" style={{ fontSize: 12 }}>{t('inbound_item.expected', { defaultValue: '預計' })}</Text>
            <div><Text strong style={{ fontSize: 16 }}>{scannedItem.scheduled_quantity}</Text></div>
          </div>
          {hasBeenVerified && (
            <div>
              <Text type="secondary" style={{ fontSize: 12 }}>{t('operator.inbound_item.received', { defaultValue: '已收' })}</Text>
              <div><Text strong style={{ fontSize: 16, color: '#52c41a' }}>{totalReceived}</Text></div>
            </div>
          )}
          {scannedItem.inventory_type_name && (
            <div>
              <Text type="secondary" style={{ fontSize: 12 }}>{t('inventory_type.name', { defaultValue: '庫存類型' })}</Text>
              <div><Text strong style={{ fontSize: 14 }}>{scannedItem.inventory_type_name}</Text></div>
            </div>
          )}
        </Space>
      </Card>
    </div>
  );
}
